import { i18n } from "@lingui/core";
import { I18nProvider as LinguiProvider } from "@lingui/react";
import type { ReactNode } from "react";

type I18nProviderProps = {
  children: ReactNode;
};

// Язык активируется до первого рендера (src/main.tsx), здесь только провайдер Lingui.
export const I18nProvider = ({ children }: I18nProviderProps) => (
  <LinguiProvider i18n={i18n}>{children}</LinguiProvider>
);
